import { inject } from '@angular/core';
import { Routes, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { LoginComponent } from './base/login/login.component';
import { ChangePasswordComponent } from './base/change-password/change-password.component';

import { AuthGuard } from './base/guards/auth.guard';
import * as pages from './core/routing/page-names';
import { EditProfileComponent } from './base/edit-profile/edit-profile.component';
import { SetPasswordComponent } from './base/set-password/set-password.component';
import { ForgotPasswordComponent } from './base/forgot-password/forgot-password.component';
import { AdminGuard } from './base/guards/admin.guard';
import { StatusDashboardComponent } from './domain/status-dashboard/status-dashboard.component';
import { ServicesAdministrationComponent } from './domain/administration/services/services-administration.component';
import { IncidentsAdministrationComponent } from './domain/administration/incidents/incidents-administration.component';
import { PopupsAdministrationComponent } from './domain/administration/popups/popups-administration.component';
import { ServiceClientsAdministrationComponent } from './domain/administration/clients/service-clients-administration.component';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: pages.statusDashboardPageName
  },
  {
    path: pages.statusDashboardPageName,
    component: StatusDashboardComponent
  },
  {
    path: pages.servicesAdministrationPageName,
    component: ServicesAdministrationComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
  },
  {
    path: pages.incidentsAdministrationPageName,
    component: IncidentsAdministrationComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
  },
  {
    path: pages.popupsAdministrationPageName,
    component: PopupsAdministrationComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
  },
  {
    path: pages.serviceClientsAdministrationPageName,
    component: ServiceClientsAdministrationComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AdminGuard).canActivate(route, state)]
  },
  {
    path: pages.loginPageName,
    component: LoginComponent
  },
  {
    path: pages.changePasswordPageName,
    component: ChangePasswordComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.editProfilePageName,
    component: EditProfileComponent,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AuthGuard).canActivate(route, state)]
  },
  {
    path: pages.setPasswordPageName,
    component: SetPasswordComponent
  },
  {
    path: pages.forgotPasswordPageName,
    component: ForgotPasswordComponent
  }
];
